module.exports = __webpack_public_path__ + "static/media/046-flag.6266b483.svg";